import { render, staticRenderFns } from "./ListLicenses.vue?vue&type=template&id=579a42fc&"
import script from "./ListLicenses.vue?vue&type=script&lang=js&"
export * from "./ListLicenses.vue?vue&type=script&lang=js&"
import style0 from "./ListLicenses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports